import React from 'react';

export function ListItem(props) {
    return <p>{props.texto}</p>
}